<template>
  <span v-bind="$attrs">{{ flag }}</span>
</template>

<script setup>
  const props = defineProps({
    country: {
      type: String,
      required: true
    }
  });

  const countryCodeToEmoji = (code) => {
    if (!code || code.length !== 2) return '🏳️';
    const codePoints = code
      .toUpperCase()
      .split('')
      .map((char) => 127397 + char.charCodeAt(0));
    return String.fromCodePoint(...codePoints);
  };

  const flag = computed(() => countryCodeToEmoji(props.country));
</script>
